import React from 'react';
import Avatar from 'react-avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Text, Theme } from '@simplybenefits/sb-ui-library';
import { styled } from '@mui/system';
import { checkEmail } from '../services/helpers.js';

const StyledMenu = styled(Menu)({
    '& .MuiPaper-root': {
        borderRadius: 8,
        minWidth: 240
    }
});

/**
 * 
 * @param {*} param0 
 */
const MasterMetaMenu = ({ open, onClose, anchorEl, toggleModal, handleCloseMenu, logout, navigate, email, testid }) => {
    const styles = {
        menuItemBorder: {
            borderBottom: `${ Theme.colors.surface } solid 1px`
        },
        navDropMenuItem: {
            height: 'auto',
            justifyContent: 'center',
            minWidth: '100%',
            padding: '5px',
            paddingTop: '10px'
        },
        navDropMenuItemMain: {
            padding: '30px',
            paddingTop: '20px',
            textAlign: 'center'
        }
    };

    return (
        <StyledMenu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            disableAutoFocusItem={true}
            anchorOrigin={ { vertical: "top", horizontal: "left" } }
        >
            <div style={styles.menuItemBorder} onClick={handleCloseMenu} id={testid}>
                <div style={styles.navDropMenuItemMain}>
                    <Avatar
                        name={email}
                        size="55"
                        textSizeRatio={2.2}
                        round={false}
                        color={Theme.colors.skyBlue}
                        style={{ marginBottom: 20 }}
                    />
                    <Text
                        align={'center'}
                        medium
                        light
                        display="block"
                    >
                        {email}
                    </Text>
                </div>
            </div>

            <MenuItem style={styles.navDropMenuItem} onClick={toggleModal}>
                <Text
                    align="center"
                    medium
                    display="block"
                    customLinkStyle={{ textDecoration: 'none' }}
                >
                Settings
                </Text>
            </MenuItem>

            {
                checkEmail(email) &&
                <MenuItem style={styles.navDropMenuItem} onClick={() => navigate('permissions')}>
                    <Text
                        align="center"
                        medium
                        display="block"
                    >
                        Permissions
                    </Text>
                </MenuItem>
            }

            <MenuItem style={styles.navDropMenuItem} onClick={logout} >
                <Text
                    color={Theme.colors.red}
                    align="center"
                    medium
                    display="block"
                >
                Logout
                </Text>
            </MenuItem>
        </StyledMenu>
    );
};

export default MasterMetaMenu;